import { RiskNameEnum } from './postureMuscle'
import { GetPostureReportResponse, RiskResult, PointResult, PointsResult } from '../../../api/algorithm/posture/posture'
export interface Direction {
    left: string
    right: string
    none: string
}
export type PD = 'front' | 'side'

export interface CanvasRectItem {
    name: RiskNameEnum,
    origin: RiskResult,
    d: PD
    img: HTMLImageElement
    url: string
    canvasId: RiskNameEnum
    direction: string
}
export class RiskCanvas {
    risks: CanvasRectItem[] = []

    frontUrl: string = ''
    sideUrl: string = ''

    frontPoints: PointsResult = Object.assign({})
    sidePoints: PointsResult = Object.assign({})

    frontImg: HTMLImageElement = Object.assign({})
    sideImg: HTMLImageElement = Object.assign({})

    // scaleX: number = 2;
    // scaleY: number = 2;
    canvas: HTMLCanvasElement = Object.assign({});

    constructor(data: any) {
        
        let frontRisk = data.body?.front?.risks || []
        let sideRisk = data.body?.side?.risks || []

        let frontPoints = data.body?.front?.points || {}
        let sidePoints = data.body?.side?.points || {}
        
        let partDirection = data.body?.side?.side || ""
        let frontUrl = data.front || ""
        let sideUrl = data.side || ""

        this.frontUrl = frontUrl
        this.sideUrl = sideUrl

        this.frontPoints = frontPoints
        this.sidePoints = sidePoints

        let riskKeyExist: any = []

        frontRisk.filter((item) => {
            if (!riskKeyExist.includes(item.key)) {
                let name: RiskNameEnum = item.key as any;
                let direction = item.direction || "";
                let canvasId: RiskNameEnum = item.key as any;

                let canvasRectItem: CanvasRectItem = {
                    canvasId: canvasId,
                    name: name,
                    img: Object.assign({}),
                    origin: item,
                    url: frontUrl,
                    d: "front",
                    direction: direction
                }
                this.risks.push(canvasRectItem)
            }
        })
        sideRisk.filter((item) => {
            if (!riskKeyExist.includes(item.key)) {
                let name: RiskNameEnum = item.key as any;
                let direction = partDirection || "";
                let canvasId: RiskNameEnum = item.key as any;
                let canvasRectItem: CanvasRectItem = {
                    name: name,
                    canvasId,
                    img: Object.assign({}),
                    url: sideUrl,
                    origin: item,
                    d: "side",
                    direction: direction
                }
                this.risks.push(canvasRectItem)
            }
        })
        this.loadImg()


    }
    loadImg = async () => {
        let fimg = new Image();
        fimg.src = this.frontUrl || ""
        fimg.onload = () => {
            this.frontImg = fimg
            this.initCanvas("front", fimg)
        }
        let sImg = new Image();
        sImg.src = this.sideUrl || ""
        sImg.onload = () => {
            this.sideImg = sImg
            this.initCanvas("side", sImg)
        }
    }
    getCenterPoint = (p, pEnd) => {

        let x = (p.x + pEnd.x) / 2
        let y = (p.y + pEnd.y) / 2
        return {
            x, y,
        }
    }
    getClipXY = (item: CanvasRectItem) => {
        let key = item.name+item.direction
        let points: any = this.frontPoints
        let d = item.d;
        if (d == "side") {
            points = this.sidePoints
        }

        let clip = {
            dis: 0,
            clipX: 0,
            clipY: 0
        }
        if (key.indexOf("lateralhead") >= 0) {  // 头部侧倾
            let headPoint = points.nose;
            if ((!headPoint || (headPoint.x === 0 && headPoint.y === 0)) && points.ear && points.ear.left && points.ear.right) {
                headPoint = this.getCenterPoint(points.ear.left, points.ear.right);
            }
            let p = this.getCenterPoint(headPoint, points.neck);
            let dis = Math.abs(headPoint.y - points.neck.y) * 1.1
            clip.clipX = p.x - dis / 2
            clip.clipY = p.y - dis / 2
            clip.dis = dis;
        }
        if (key.indexOf("unevenshoulder") >= 0) {   // 高低肩
            let p = points.neck;
            let dis = Math.abs(points.shoulder.left.x - points.shoulder.right.x) * 1.1
            clip.clipX = p.x - dis / 2
            clip.clipY = p.y - dis / 2
            clip.dis = dis;
        }
        if (key.indexOf("scoliosis") >= 0) {  // 脊椎异位
            let p = this.getCenterPoint(this.getCenterPoint(points.hip.left, points.hip.right), points.neck);
            let dis = Math.abs(points.neck.y - points.hip.left.y) * 1.1
            clip.clipX = p.x - dis / 2
            clip.clipY = p.y - dis / 2
            clip.dis = dis;
        }
        if (key.indexOf("unevenhip") >= 0) {  // 骨盆侧倾
            let p = this.getCenterPoint(points.hip.left, points.hip.right);
            let dis = Math.abs(points.hip.left.x - points.hip.right.x) * 2
            clip.clipX = p.x - dis / 2
            clip.clipY = p.y - dis / 2
            clip.dis = dis;
        }

        if (key.indexOf("forwardhead") >= 0) { // 头部前倾
            if(item.direction === 'left') {
                let p = this.getCenterPoint(points.ear.left, points.shoulder.left);
                let dis = Math.abs(points.ear.left.y - points.shoulder.left.y) * 1.1
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
            else {
                let p = this.getCenterPoint(points.ear.right, points.shoulder.right);
                let dis = Math.abs(points.ear.right.y - points.shoulder.right.y) * 1.1
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
        }
        if (key.indexOf("kneehyperextension") >= 0) { // 膝过伸
            if(item.direction === 'left') {
                let p = points.knee.left;
                let dis = Math.abs(points.hip.left.y - points.ankle.left.y) * 1.1
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
            else {
                let p = points.knee.right;
                let dis = Math.abs(points.hip.right.y - points.ankle.right.y) * 1.1
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
            
        }
        if (key.indexOf("roundedshoulder") >= 0) { // 圆肩
            if(item.direction === 'left') {
                let p = points.shoulder.left;
                let dis = Math.abs(points.ear.left.y - points.shoulder.left.y) * 1.5
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
            else {
                let p = points.shoulder.right;
                let dis = Math.abs(points.ear.right.y - points.shoulder.right.y) * 1.5
                clip.clipX = p.x - dis / 2
                clip.clipY = p.y - dis / 2
                clip.dis = dis;
            }
            
        }
        if ((key.indexOf("oleg") >= 0) || (key.indexOf("xleg") >= 0) || (key.indexOf("xoleg") >= 0)) {
            let p = this.getCenterPoint(points.knee.left, points.knee.right);
            let dis = Math.abs(points.hip.left.y - points.knee.left.y) * 1.2
            clip.clipX = p.x - dis / 2
            clip.clipY = p.y - dis / 2
            clip.dis = dis;
        }
        return clip;
    }
    drawImage = (ctx: CanvasRenderingContext2D, item: CanvasRectItem) => {


        let { width: canvasW, height: canvasH } = this.canvas.getBoundingClientRect()
        this.canvas.style.width = canvasW + "px"
        this.canvas.style.height = canvasH + "px"
        this.canvas.height = canvasH
        this.canvas.width = canvasW

        let clip = this.getClipXY(item);
        ctx.save()
        ctx.drawImage(item.img, clip.clipX, clip.clipY, clip.dis, clip.dis, 0, 0, canvasW, canvasH)
        ctx.restore()
    }
    initCanvas = (d: PD, img: HTMLImageElement) => {

        let risks = this.risks.filter((item) => {
            item.img = img;
            return item.d == d;
        })
        risks.forEach((item) => {
            let direction =""
            if(item.origin.key.indexOf("leg")>=0){
                direction =item.origin.direction
            }
            try {
                let canvas = <HTMLCanvasElement>document.getElementById(item.canvasId+direction)
                this.canvas = canvas;
                let ctx = <CanvasRenderingContext2D>canvas.getContext('2d')
                this.drawImage(ctx, item);

            } catch (error: any) {

            }
        })
    }
}



